export interface ComponentOptionsBase {
}

export abstract class ComponentBase<T extends ComponentOptionsBase> {
    protected _options: T;

    constructor(options: T) {
        this._options = options;
        this.init = this.init.bind(this);

        $(document).ready(this.init);
    }

    abstract init(): void;
}


/** WEBPACK FOOTER **
 ** ./Typescript/Common/ComponentBase.ts
 **/